//@flow
import React, { Component } from 'react';
import { connect } from "react-redux";
import Select from 'react-select';
import { CTAButton, TextField, validateForm, validateEmail, Modal } from 'h-signup';
import 'react-select/dist/react-select.css';
import './invitee-styles.css';
import { getValidationObjects } from './utils';
import { createSmAndNavigate, skipMailboxCreation, resetSmData } from '../../../actions'
import {
	FormSection,
	FormTitle,
	StyledLink,
    FieldLabel,
    NextBtn
} from './styledComponents'
import { ErrorMessage, ErrorTitle, ErrorAction } from '../Verify/styledComponents'
import ErrorIcon from '../../../../common/images/icecream-drop.png'
import { sendGenricTrackingEvent } from 'h-commons';
import { setUserPropertyActionCreator } from '../../../../../../js/modules/common';
import { SM_USAGE_INPUT_LIST, SM_USAGE_INPUT_TITLE } from '../../../../../../js/modules/sharedmailbox/common/constants';
import CreateSMTypeDropdown from './createSMTypeDropdown';

class CreateSmForm extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
            source_email: {
                ref: null, value: ''
            },
            display_name: {
                ref: null, value: ''
            },
            sm_type: {
                ref: null, value: ''
            },
            target_emails: [],
			multi: true,
			submitInProgress: false,
            submitError: false,   
            smTypeErrorText: "",
        };
    }
    
    componentDidUpdate() {
        if (this.props.smData.submitError !== this.state.submitError) {
            const { submitError, submitInProgress } = this.props.smData;
            this.setState({
                submitError,
                submitInProgress
            });
        }
    }

    componentDidMount() {
        const { email } = this.props.userDetails;
        const values = [{
            label: email,
            value: email,
            clearableValue: false
        }]
        this.setState({ target_emails: values });
    }
    

    handleSkipLink = (event) => {
        event.preventDefault();
        const data = { skipMailboxCreation: true };
        sendGenricTrackingEvent('setupSharedMailboxSignup', { state: 'skip', userid: this.props.userDetails.id });
        this.props.skipSm(data, 'success');
    }

	handleFormSubmit = async (event) => {
        event.preventDefault();
        const { submitInProgress } = this.state;
        const { userDetails,setUserProperties } = this.props;
        const { required } = getValidationObjects();
        if (submitInProgress) return;
        const validMap = {
            source_email: false, display_name: false
        }
		const formValid = await validateForm(validMap, this.state, 2);
        const { source_email, display_name, target_emails, sm_type } = this.state;
        if(!formValid || !required.func(sm_type.value)){
            this.handleSMTypeValidations(sm_type.value);
            return;
        }
		const user_emails = target_emails.map(item => item.value);
		const data = {
			source_email: source_email.value.trim(),
			display_name: display_name.value.trim(),
            sm_type: sm_type.value.trim(),
			target_emails: user_emails,
        }
        sendGenricTrackingEvent('setupSharedMailboxSignup',
        { state: 'success',
          userid: userDetails.id,
          hasInvitedUsers: (data.target_emails || []).length > 0,
          noOfInvitedUsers: (data.target_emails || []).length
        });
		this.setState({
            submitInProgress: true
        }, () => {
			this.props.createSm(data, 'verify');
            setUserProperties({property:'create_sm_step_completed',value:"true"});
            if((data.target_emails || []).length > 1){
                setUserProperties({property:'invite_user_step_completed',value:"true"});
            }
		});
	}

	updateField = (value: string, target: string) => {
        this.setState({
            [target]: {
                ref: this.state[target].ref,
                value
            }
        })
    }
    updateRef = (ref: any, target: string) => {
        this.setState({
            [target]: {
                ref,
                value: this.state[target].value
            }
        })
    }

	handleChange = (values: []) => {
		this.setState({ target_emails: values });
	}

    handleSMTypeValidations = (value) => {
        const { smTypeValidations } = getValidationObjects();
        this.setState({ smTypeErrorText: smTypeValidations(value) });
    };

    handleSMTypeValueChange = (value, updateField = false) => {
        if(updateField) this.updateField(value, 'sm_type');
        this.handleSMTypeValidations(value);
    }

	renderForm() {
		const { required, email, maxLength } = getValidationObjects();
		const { submitInProgress, target_emails, smTypeErrorText } = this.state;
		return <FormSection onSubmit={this.handleFormSubmit}>
			<FormTitle>Set up shared mailbox</FormTitle>
			<br />
            <TextField label="Email address of shared mailbox"
                style={{"marginTop": "14px"}}
                validations={[required, email]}
                innerRef={(ref => this.updateRef(ref, 'source_email'))}
                onChange={(value) => this.updateField(value, 'source_email')}
                placeholder='support@company.com'
                attachSVG={true}
                LabelSectionStyle={{"marginTop": "12px"}}
            />
			<TextField label="Shared mailbox name"
                validations={[required, maxLength]}
                innerRef={(ref => this.updateRef(ref, 'display_name'))}
                onChange={(value) => this.updateField(value, 'display_name')}
                placeholder='Eg : Support'
                LabelSectionStyle={{"marginTop": "12px"}}
            />
            <FieldLabel>{SM_USAGE_INPUT_TITLE}</FieldLabel>
            <CreateSMTypeDropdown
                errorText={smTypeErrorText}
                onValueChange={this.handleSMTypeValueChange}
                dropdownlist={SM_USAGE_INPUT_LIST}
            />
            <FieldLabel>Invite users</FieldLabel>
			<Select.Creatable
                multi
                className={ target_emails.length > 1 ? "invitee-field has-selected-value" : "invitee-field"}
                name="target_emails"
                value={target_emails}
                noResultsText={null}
                openOnFocus={false}
				autosize={false}
                openOnClick={false}
                arrowRenderer={null}
                onBlurResetsInput={false}
				onChange={this.handleChange.bind(this)}
				menuRenderer={undefined}
                clearable={false}
				promptTextCreator={(label: string) => (`Invite user: ${label}`)}
				isValidNewOption={(option) => (validateEmail(option.label))}
            />
			<CTAButton isLoading={submitInProgress} width="233px" type="submit" style={NextBtn}>
				Next
			</CTAButton>
			<br />
			<StyledLink to="" onClick={this.handleSkipLink}>I'll do this later</StyledLink>
		</FormSection>
    }
    
    
    resetSmData = () => {
       const { resetSmData } = this.props; 
       resetSmData();
    }

	renderError() {
        const { submitError } = this.state;
        if (!submitError) return null;
        return [
			<img key="error-icon" src={ErrorIcon} />,
			<ErrorTitle key="error-title">
                Error
            </ErrorTitle>,
			<ErrorMessage key="error-msg">
                { submitError.message || 'Some error occured. Please Try Again.'}
            </ErrorMessage>,
			<ErrorAction onClick={this.resetSmData} key="error-action">Retry</ErrorAction>
		]
    }

	render () {
		const { submitError } = this.state;
		return <div>
            {  this.renderForm() }
            <Modal open={submitError} onClose={this.resetSmData}>
                { this.renderError() }
            </Modal>
		</div>
	}
}

type Props = {
    createSm: Function,
    smData: Object,
    skipSm: Function,
    userDetails: Object,
    resetSmData: Function
};

type TextFieldType = {
    ref: Component<any, any> | null,
    value: string
};

type State = {
    source_email: TextFieldType,
    display_name: TextFieldType,
    target_emails: any,
	multi: boolean,
	submitInProgress: boolean,
	submitError: any
};

const mapStateToProps = ({smData, userDetails}) => {
    return {
        smData,
        userDetails
    };
};

const mapDispatchToProps = (dispatch: Function) => ({
	createSm: (reqObj, changeToRoute) => dispatch(createSmAndNavigate(reqObj, changeToRoute)),
    skipSm: (reqObj, changeToRoute) => dispatch(skipMailboxCreation(reqObj, changeToRoute)),
    resetSmData: () => dispatch(resetSmData()),
    setUserProperties : ({property,value})=>dispatch(setUserPropertyActionCreator({property,value}))

});

export default connect(mapStateToProps, mapDispatchToProps)(CreateSmForm);
